import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/guard/auth.guard';
import { DomainGuard } from 'src/app/core/guard/DomainGuard';
import { WMSM001Component } from './WMSM001/WMSM001.component';
import { WMSM002Component } from './WMSM002/WMSM002.component';
import { WMSMComponent } from './WMSM.component'
import { Wmsm009Component } from './wmsm009/wmsm009.component'
import { WmsmOnlineFileComponent } from './wmsm-OnlineFile/wmsm-OnlineFile.component'
import { WmsmIDApplicationComponent } from './wmsm-IDApplication/wmsm-IDApplication.component'
import { WmsmCaseCloseComponent } from './wmsm-CaseClose/wmsm-CaseClose.component'
import { WmsmChangeHistoryComponent } from './wmsm-ChangeHistory/wmsm-ChangeHistory.component'
import { WmsmDowmloadSupplierListComponent } from './wmsm-DowmloadSupplierList/wmsm-DowmloadSupplierList.component'
import { WmsmRoleAccountsComponent } from './wmsm-RoleAccounts/wmsm-RoleAccounts.component'
import { WmsmStatementQueryComponent } from './wmsm-StatementQuery/wmsm-StatementQuery.component'
import { WmsmStatementMaintainComponent } from './wmsm-StatementMaintain/wmsm-StatementMaintain.component'
import { EditWmsmStatementMaintainComponent } from './wmsm-StatementMaintain/edit-wmsm-StatementMaintain/edit-wmsm-StatementMaintain.component'
import { WmsmStatementabnormalComponent } from './wmsm-Statementabnormal/wmsm-Statementabnormal.component'
import { WmsmExcludevendorComponent } from './wmsm-excludevendor/wmsm-excludevendor.component'
import { WmsmAribaPageComponent } from './wmsm-AribaPage/wmsm-AribaPage.component'
import { WmsmPMCSPageComponent } from './wmsm-PMCSPage/wmsm-PMCSPage.component'
import { WmsmMaintainVenderABTypeComponent } from './wmsm-MaintainVenderABType/wmsm-MaintainVenderABType'
import { WmsmStatementQueryWHQComponent } from './wmsm-StatementQueryWHQ/wmsm-StatementQueryWHQ.component'
import { WmsmStatementMaintainWHQComponent } from './wmsm-StatementMaintainWHQ/wmsm-StatementMaintainWHQ.component'
import { WmsmStatementAbnormalWHQComponent } from './wmsm-StatementabnormalWHQ/wmsm-StatementabnormalWHQ.component'
import { EditWmsmStatementMaintainWHQComponent } from './wmsm-StatementMaintainWHQ/edit-wmsm-StatementMaintainWHQ/edit-wmsm-StatementMaintainWHQ.component'
import { EditWmsmElectronicInvoice } from './wmsm-StatementMaintainWHQ/edit-wmsm-ElectronicInvoice/edit-wmsm-ElectronicInvoice.component';
import { EditWmsmManualInvoice } from './wmsm-StatementMaintainWHQ/edit-wmsm-ManualInvoice/edit-wmsm-ManualInvoice.component';
import { WmsmAdminDowmloadSupplierListComponent } from './wmsm-AdminDowmloadSupplierList/wmsm-AdminDowmloadSupplierList.component';
import { WmsmSiteAdminRoleComponent } from './wmsm-SiteAdminRole/wmsm-SiteAdminRole.component';
import { WmsmMaintenanceSystemBulletinComponent } from './wmsm-MaintenanceSystemBulletin/wmsm-MaintenanceSystemBulletin.component';
import { WmsmContractTemplateManagementComponent } from './wmsm-ContractTemplateManagement/wmsm-ContractTemplateManagement.component';
import { WmsmMailServiceManagementComponent } from './wmsm-MailServiceManagement/wmsm-MailServiceManagement.component';
import { WmsmModuleManagementComponent } from './wmsm-ModuleManagement/wmsm-ModuleManagement.component';
import { WmsmContractSendingComponent } from './wmsm-ContractSending/wmsm-ContractSending.component';
import { WmsmScheduleManagementComponent } from './wmsm-ScheduleManagement/wmsm-ScheduleManagement.component';
import { WmsmMenuManagementComponent } from './wmsm-menu-management/wmsm-menu-management.component';
import { WmsmRoleManagementComponent } from './wmsm-role-management/wmsm-role-management.component';
import { SourcingRequestSettingComponent } from './BaseData/sourcing-request-setting/sourcing-request-setting.component';
import { MroExpertSettingComponent } from './BaseData/mro-expert-setting/mro-expert-setting.component';
import { WmsmRegisterVendor } from './wmsm-RegisterVendor/wmsmRegisterVendor.component';
import { MVMTestComponent } from './wmsm-mvmtest/mvmtest.component';


const routes: Routes = [
  { path: '', component: WMSMComponent, canActivate: [AuthGuard] },


  {
    path: 'Deliveryinteraction',
    //component: WMSM001Component,
    //canActivate: [AuthGuard,DomainGuard] ,
    data: { breadcrumbStr: 'Deliveryinteraction' },
    children: [
      {
        path: 'wmsm001',
        component: WMSM001Component,
        canActivate: [AuthGuard, DomainGuard],
        data: { breadcrumbStr: 'deliveryMaintain' }
      }, {
        path: 'deliveryQuery',
        //component: WMSM001Component,
        //canActivate: [AuthGuard,DomainGuard] ,
        data: { breadcrumbStr: 'deliveryQuery' },
        children: [
          {
            path: 'wmsm002',
            component: WMSM002Component,
            canActivate: [AuthGuard, DomainGuard],
            data: { breadcrumbStr: 'deliveryReport' }
          },
          {
            path: 'wmsmChangeHistory', component: WmsmChangeHistoryComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ConfirmationHistory' }
          }
        ]
      }
    ]

  },
  {
    path: 'SupplierManagement',
    //component: WMSM001Component,
    //canActivate: [AuthGuard,DomainGuard] ,
    data: { breadcrumbStr: 'SupplierManagement' },
    children: [
      {
        path: 'StatementPaymentManagement',
        data: { breadcrumbStr: 'StatementPaymentManagement' },
        children: [
          {
            path: 'wmsmStatementQuery', component: WmsmStatementQueryComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'StatementQuery' }
          },
          {
            path: 'wmsmStatementMaintain', component: WmsmStatementMaintainComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'StatementMaintain', reuse: true }
          },
          {
            path: 'wmsmStatementAbnormal', component: WmsmStatementabnormalComponent, canActivate: [AuthGuard], data: { breadcrumbStr: 'StatementAbnormal' }
          }
        ]
      },
      {
        path: 'StatementPaymentManagementWHQ',
        data: { breadcrumbStr: 'StatementPaymentManagementWHQ' },
        children: [
          {
            path: 'wmsmStatementQueryWHQ', component: WmsmStatementQueryWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'StatementQuery' }
          },
          {
            path: 'wmsmStatementMaintainWHQ', component: WmsmStatementMaintainWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'StatementMaintain', reuse: true }
          },
          {
            path: 'wmsmStatementAbnormalWHQ', component: WmsmStatementAbnormalWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'StatementAbnormal' }
          }
        ]
      }
    ],


  },
  {
    path: 'ContractManagement',
    //component: WMSM001Component,
    //canActivate: [AuthGuard,DomainGuard] ,
    data: { breadcrumbStr: 'ContractManagement' },
    children: [
      {
        path: 'wmsmContractTemplateManagement', component: WmsmContractTemplateManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ContractTemplateManagement' }
      }, {
        path: 'ContractScheduleManagement',
        //component: WMSM001Component,
        //canActivate: [AuthGuard,DomainGuard] ,
        data: { breadcrumbStr: 'ContractScheduleManagement' },
        children: [
          {
            path: 'wmsmContractSending', component: WmsmContractSendingComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ContractSending' }
          },
          {
            path: 'wmsmScheduleManagement', component: WmsmScheduleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmScheduleManagementComponent' }
          }
        ]
      }
    ],
  },
  {
    path: 'NormalSetting',
    //component: WMSM001Component,
    //canActivate: [AuthGuard,DomainGuard] ,
    data: { breadcrumbStr: 'NormalSetting' },
    children: [
      {
        path: 'wmsmIDApplication', component: WmsmIDApplicationComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'IDApplication' }
      },
      {
        path: 'wmsm009', component: Wmsm009Component, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ProxySetting' }
      },
      {
        path: 'vendorregister', component: WmsmRegisterVendor, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'RegisterVendor' }
      }
    ],
  }, {
    path: 'Setting',
    //component: WMSM001Component,
    //canActivate: [AuthGuard,DomainGuard] ,
    data: { breadcrumbStr: 'Setting' },
    children: [
      {
        path: 'wmsmOnlineFile', component: WmsmOnlineFileComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'OnlineFile' }
      },
      {
        path: 'wmsmExcludeVendor', component: WmsmExcludevendorComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ExcludeVendor' }
      },
      {
        path: 'wmsmMaintenanceSystemBulletin', component: WmsmMaintenanceSystemBulletinComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'MaintenanceSystemBulletin' }
      },
      {
        path: 'wmsmSiteAdminRole', component: WmsmSiteAdminRoleComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'SiteAdminRole' }
      },
      {
        path: 'wmsmMailServiceManagement', component: WmsmMailServiceManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'MailServiceManagement' }
      },
      {
        path: 'wmsmModuleManagement', component: WmsmModuleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'ModuleManagement' }
      }, {
        path: 'AccountPermissions',
        //component: WMSM001Component,
        //canActivate: [AuthGuard,DomainGuard] ,
        data: { breadcrumbStr: 'AccountPermissions' },
        children: [
          {
            path: 'wmsmRoleAccounts', component: WmsmRoleAccountsComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmRoleAccountsComponent' }
          },
          {
            path: 'wmsmCaseClose', component: WmsmCaseCloseComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmCaseCloseComponent' }
          },
          {
            path: 'wmsmSupplierAccountList', component: WmsmDowmloadSupplierListComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'SupplierAccountList' }
          },
          {
            path: 'wmsmAdminSupplierAccountList', component: WmsmAdminDowmloadSupplierListComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'AdminSupplierAccountList' }
          },
          {
            path: 'wmsmMenuManagement', component: WmsmMenuManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'MenuManagement' }
          },
          {
            path: 'wmsmRoleManagement', component: WmsmRoleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'RoleManagement' }
          }
        ]
      }
    ],
  },

  {
    path: 'Source',
    data: { breadcrumbStr: 'sourcing_pricing_management' },
    children: [
      {
        path: 'BaseData',
        data: { breadcrumbStr: 'BaseDataMaintenance' },
        children: [
          {
            path: 'SRSetting', component: SourcingRequestSettingComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'SRSettingMaintenance' }
          },
          {
            path: 'MROExpertSetting', component: MroExpertSettingComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'MROExpertSetting' }
          }
        ],
      }
    ],
  },
  { path: 'wmsm001', component: WMSM001Component, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WMSM001Component' } },
  { path: 'wmsm002', component: WMSM002Component, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WMSM002Component' } },
  { path: 'wmsm009', component: Wmsm009Component, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'Wmsm009Component' } },
  { path: 'wmsm009', component: Wmsm009Component, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'Wmsm009Component' } },
  { path: 'wmsmOnlineFile', component: WmsmOnlineFileComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmOnlineFileComponent' } },
  { path: 'wmsmIDApplication', component: WmsmIDApplicationComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmIDApplicationComponent' } },
  { path: 'wmsmCaseClose', component: WmsmCaseCloseComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmCaseCloseComponent' } },
  { path: 'wmsmChangeHistory', component: WmsmChangeHistoryComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmChangeHistoryComponent' } },
  { path: 'wmsmSupplierAccountList', component: WmsmDowmloadSupplierListComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmDowmloadSupplierListComponent' } },
  { path: 'wmsmAdminSupplierAccountList', component: WmsmAdminDowmloadSupplierListComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmAdminDowmloadSupplierListComponent' } },
  { path: 'wmsmRoleAccounts', component: WmsmRoleAccountsComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmRoleAccountsComponent' } },
  { path: 'wmsmMenuManagement', component: WmsmMenuManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmMenuManagementComponent' } },
  { path: 'wmsmRoleManagement', component: WmsmRoleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmRoleManagementComponent' } },
  { path: 'wmsmStatementQuery', component: WmsmStatementQueryComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmStatementQueryComponent' } },
  { path: 'wmsmStatementMaintain', component: WmsmStatementMaintainComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmStatementMaintainComponent' } },
  { path: 'wmsmStatementMaintain-edit', component: EditWmsmStatementMaintainComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'EditWmsmStatementMaintainComponent' } },
  { path: 'wmsmStatementAbnormal', component: WmsmStatementabnormalComponent, canActivate: [AuthGuard], data: { breadcrumbStr: 'WmsmStatementabnormalComponent' } },
  { path: 'wmsmExcludeVendor', component: WmsmExcludevendorComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmExcludevendorComponent' } },
  { path: 'wmsmAribaPage', component: WmsmAribaPageComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmAribaPageComponent' } },
  { path: 'wmsmPMCSPage', component: WmsmPMCSPageComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmPMCSPageComponent' } },
  { path: 'wmsmMaintainVenderABType', component: WmsmMaintainVenderABTypeComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmMaintainVenderABTypeComponent' } },
  { path: 'wmsmStatementQueryWHQ', component: WmsmStatementQueryWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmStatementQueryWHQComponent' } },
  { path: 'wmsmStatementMaintainWHQ', component: WmsmStatementMaintainWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmStatementMaintainWHQComponent' } },
  { path: 'wmsmStatementAbnormalWHQ', component: WmsmStatementAbnormalWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmStatementAbnormalWHQComponent' } },
  { path: 'wmsmStatementMaintainWHQ-edit', component: EditWmsmStatementMaintainWHQComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'EditWmsmStatementMaintainWHQComponent' } },
  { path: 'EditWmsmElectronicInvoice', component: EditWmsmElectronicInvoice, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'EditWmsmElectronicInvoice' } },
  { path: 'EditWmsmManualInvoice', component: EditWmsmManualInvoice, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'EditWmsmManualInvoice' } },
  { path: 'wmsmSiteAdminRole', component: WmsmSiteAdminRoleComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmSiteAdminRoleComponent' } },
  { path: 'wmsmMaintenanceSystemBulletin', component: WmsmMaintenanceSystemBulletinComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmMaintenanceSystemBulletinComponent' } },
  { path: 'wmsmContractTemplateManagement', component: WmsmContractTemplateManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmContractTemplateManagementComponent' } },
  { path: 'wmsmMailServiceManagement', component: WmsmMailServiceManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmMailServiceManagementComponent' } },
  { path: 'wmsmModuleManagement', component: WmsmModuleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmModuleManagementComponent' } },
  { path: 'wmsmContractSending', component: WmsmContractSendingComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmContractSendingComponent' } },
  { path: 'wmsmScheduleManagement', component: WmsmScheduleManagementComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'WmsmScheduleManagementComponent' } },
  { path: 'mvmentest', component: MVMTestComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'mvmentest' } },
  { path: 'mvmchtest', component: MVMTestComponent, canActivate: [AuthGuard, DomainGuard], data: { breadcrumbStr: 'mvmchtest' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WMSMPagesRoutingModule { }
